import { render, staticRenderFns } from "./ProjectSquare.vue?vue&type=template&id=4cab6c57"
import script from "./ProjectSquare.vue?vue&type=script&lang=js"
export * from "./ProjectSquare.vue?vue&type=script&lang=js"
import style0 from "./ProjectSquare.vue?vue&type=style&index=0&id=4cab6c57&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports